import { useCallback, useEffect, useRef, useState } from 'react';
import { useAppSelector } from 'store/hooks';
import useFetchStateless from 'hooks/useFetch';
import { getRecurringBuyActivities } from '../actions';
const useRecurringBuyActivities = (id, forceReloadConfig) => {
    const activities = useAppSelector((state) => state.unpersistedInvestReducer.historyForRecurringBuyId)?.[id];
    const [state, setState] = useState({
        loading: true,
    });
    const initialLoading = useRef(true);
    const nextPageToken = useRef(undefined);
    const [, , , fetch] = useFetchStateless();
    const onLoadNextPage = useCallback(async () => {
        const token = nextPageToken.current;
        if (token) {
            setState((oldState) => ({ ...oldState, loading: true, error: false }));
            const params = { token };
            try {
                nextPageToken.current = undefined; // clear paging token to avoid extra requests for the same page
                const response = await fetch(getRecurringBuyActivities(id, params));
                if (response?.activities) {
                    nextPageToken.current = response.paging.next;
                }
            }
            catch {
                initialLoading.current = false;
            }
            finally {
                setState({ loading: false });
            }
        }
        else {
            // log('[onLoadNextPage] No paging token, skipping', false);
        }
    }, [id]);
    const loadFirstPage = useCallback(async () => {
        initialLoading.current = true;
        nextPageToken.current = undefined;
        setState((oldState) => ({ ...oldState, data: [], loading: true, error: false }));
        try {
            const params = { page: 1, perPage: 30 };
            const response = await fetch(getRecurringBuyActivities(id, params));
            if (response?.activities) {
                initialLoading.current = false;
                nextPageToken.current = response.paging.next;
            }
            else {
                initialLoading.current = false;
            }
        }
        catch {
            initialLoading.current = false;
        }
        finally {
            setState({ loading: false });
        }
    }, [id]);
    useEffect(() => {
        if (forceReloadConfig?.forceReload || initialLoading) {
            loadFirstPage();
        }
        // this effect should only run once or when the object forceReloadConfig changes with forceReload as true.
        // the effect is designed to rerun when navigated with params forceReloadConfig: { forceReload: true } as
        // forceReloadConfig is an object and will change when new navigation happens
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [forceReloadConfig]);
    return {
        onLoadNextPage,
        activities: activities || [],
        loading: initialLoading.current && state.loading,
    };
};
export default useRecurringBuyActivities;
